module.exports = __webpack_public_path__ + "fonts/Manrope-600-cyrillic-ext13.64f66ba.woff2";